"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInQubicDappBrowser = exports.globalEthereum = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.globalEthereum = typeof window !== 'undefined' ? window.ethereum : undefined;
exports.isInQubicDappBrowser = exports.globalEthereum && (exports.globalEthereum === null || exports.globalEthereum === void 0 ? void 0 : exports.globalEthereum.isQubic);
